// extracted by mini-css-extract-plugin
export default {"navItem":"NavMenu__navItem___ta5Cd"};